var _ellipse, _ellipse2, _path, _path2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourseAdminTabLastVisited = function SvgCourseAdminTabLastVisited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.375,
    cy: 20.625,
    fill: "#0E72ED",
    rx: 20,
    ry: 19.375
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.375,
    cy: 19.375,
    fill: "#0E72ED",
    rx: 20,
    ry: 19.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m11.472 23.313 15.032 14.562c6.129-1.875 10.968-6.562 12.903-12.5L29.214 15.5z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF2",
    fillRule: "evenodd",
    d: "M20.375 11.25c-6.387 0-11.613 6.875-11.613 8.125S13.988 27.5 20.375 27.5s11.613-6.875 11.613-8.125-5.226-8.125-11.613-8.125",
    clipRule: "evenodd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.375,
    cy: 19.375,
    fill: "#0E72ED",
    rx: 5.161,
    ry: 5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.085,
    cy: 18.125,
    fill: "#FFFCF2",
    rx: 1.29,
    ry: 1.25
  })));
};
export { SvgCourseAdminTabLastVisited as ReactComponent };
export default __webpack_public_path__ + "fonts/course-admin-tab-last-visited-11c6209bac99285bcd530fddbafdbef0.svg";